module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7c3cee97eda772af1d4585b4c684bcc4.png";